import script from "./FilterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterBar.vue?vue&type=script&setup=true&lang=js"

import "./FilterBar.vue?vue&type=style&index=0&id=1042b568&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1042b568"]])

export default __exports__